import { PropTypes } from 'react';

// TODO: to revist the structure after the service
const TOPIC_FAQ_ITEM = {
  id: PropTypes.string,
  title: PropTypes.string,
  solutionId: PropTypes.string,
  solutionClass: PropTypes.string,
  topicId: PropTypes.string,
};

const TOPIC = {
  id: PropTypes.string,
  name: PropTypes.string,
  faqList: PropTypes.arrayOf(PropTypes.shape(TOPIC_FAQ_ITEM)),
};

const ARTICLE_LIST = {
  articleId: PropTypes.string,
  articleTitle: PropTypes.string,
  articleList: PropTypes.arrayOf(PropTypes.shape(TOPIC)),
};

const COMMUNITY = {
  error: PropTypes.bool,
  isLoading: PropTypes.bool,
  results: PropTypes.arrayOf(PropTypes.shape({
    articleTitle: PropTypes.string,
    articleId: PropTypes.number,
    views: PropTypes.number,
    link: PropTypes.string,
  })),
};

const BREADCRUMB_ITEM = {
  id: PropTypes.string,
  title: PropTypes.string,
  path: PropTypes.string,
};

const CHANNEL_DETAIL_BNA = {
  bnaId: PropTypes.string,
  bnaListId: PropTypes.string,
  intentId: PropTypes.string,
  intentPromptedTime: PropTypes.string,
};

const POPULAR_ARTICLE = {
  articleId: PropTypes.string,
  articleTitle: PropTypes.string,
  channel: PropTypes.string,
  channelDetails: PropTypes.shape(CHANNEL_DETAIL_BNA),
  rank: PropTypes.number,
  usage: PropTypes.number,
};

const CASE_PARTIES = {
  association: PropTypes.string,
  user_id: PropTypes.string,
  user_type: PropTypes.string,
};

const OPEN_CASE = {
  amount: PropTypes.shape({
    currency_code: PropTypes.string,
    value: PropTypes.string,
  }),
  case_lifecycle_stage: PropTypes.string,
  case_parties: PropTypes.arrayOf(PropTypes.shape(CASE_PARTIES)),
  case_type: PropTypes.arrayOf(PropTypes.string),
  claim_type: PropTypes.string,
  creation_timestamp: PropTypes.string,
  detailed_case_status: PropTypes.string,
  facilitator_id: PropTypes.string,
  id: PropTypes.string,
  origin: PropTypes.string,
  policy_name: PropTypes.string,
  reason_code: PropTypes.string,
  status: PropTypes.string,
};

const ARTICLE_CONTENT = {
  articleContent: PropTypes.string,
  articleId: PropTypes.string,
  articleTitle: PropTypes.string,
  breadCrumbPath: PropTypes.string,
  breadCrumbTitle: PropTypes.string,
  consumerContent: PropTypes.string,
  rank: PropTypes.number,
  topicId: PropTypes.string,
  topicName: PropTypes.string,
  usage: PropTypes.number,
};

const MACHINE_ARTICLE = {
  article: PropTypes.shape(ARTICLE_CONTENT),
  error: PropTypes.bool,
  isLoading: PropTypes.bool,
};

module.exports = {
  TOPIC,
  TOPIC_FAQ_ITEM,
  ARTICLE_LIST,
  COMMUNITY,
  BREADCRUMB_ITEM,
  CHANNEL_DETAIL_BNA,
  POPULAR_ARTICLE,
  OPEN_CASE,
  MACHINE_ARTICLE,
};
